import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotfoundComponent } from './notfound/notfound.component'; 
import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { LoaderComponent } from './modules/shared/layouts/loader/loader.component';
//import { LoaderComponent } from './layouts/loader/loader.component';


@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
    LoaderComponent

    
    //LicenceComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule, 
    HttpClientModule   
  ],
  providers: [{provide : LocationStrategy , useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
